import { mount } from "@vue/test-utils";
import SalesButton from "@/components/core/SalesButton";

describe("SalesButton test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(SalesButton);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component SalesButton", () => {
    expect(wrapper).toBeDefined();
  });
});
